/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ChatroomMemberConnectedMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler 
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ChatroomMemberConnectedMessageHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_CHATROOM_MEMBER_CONNECTED);
};
$hxClasses['com.inq.flash.client.control.messagehandlers.ChatroomMemberConnectedMessageHandler'] = com.inq.flash.client.control.messagehandlers.ChatroomMemberConnectedMessageHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.ChatroomMemberConnectedMessageHandler.__name__ = ["com","inq","flash","client","control","messagehandlers","ChatroomMemberConnectedMessageHandler"];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.ChatroomMemberConnectedMessageHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for(var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.ChatroomMemberConnectedMessageHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];

/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * override public function processMessage(message:Message):Void
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ChatroomMemberConnectedMessageHandler
 * @param {com.inq.flash.messagingframework.Message} message
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatroomMemberConnectedMessageHandler.prototype.processMessage = function (message) {
    if (message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHATROOM_MEMBER_TYPE) == com.inq.flash.client.data.MessageFields.DATA_CHATROOM_MEMBER_AGENT) {
        com.inq.flash.client.control.PersistenceManager.SetValue("va", null, true, true);
    }

	if (message.getProperty(com.inq.flash.client.data.MessageFields.KEY_OWNER) == com.inq.flash.client.data.MessageFields.DATA_TRUE) {
        // For the VA scenarios the flag connection accepted still can be in false.
        this.getController().setConnectionAccepted(true);
		this.setAgent(
			message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHATROOM_MEMBER_ID),
			message
		);
	}

	/** @type {string} */
	var isReassignMode = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_IS_REASSIGNMENT_MODE);
	/** @type {string} */
	var tcMode = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_TC_MODE);
	if (tcMode == com.inq.flash.client.data.MessageFields.DATA_TRANSFER
		|| tcMode == com.inq.flash.client.data.MessageFields.DATA_CONFERENCE && message.getProperty(com.inq.flash.client.data.MessageFields.KEY_SCREENING) == com.inq.flash.client.data.MessageFields.DATA_FALSE
		|| isReassignMode == com.inq.flash.client.data.MessageFields.DATA_TRUE) {
		com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow("",
			message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CLIENT_DISPLAY_TEXT),
			com.inq.flash.client.chatskins.ChatTextArea.SYSTEM,-1,
			null, message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY));
	}
};

/** @type {com.inq.flash.client.control.messagehandlers.ChatroomMemberConnectedMessageHandler} */
com.inq.flash.client.control.messagehandlers.ChatroomMemberConnectedMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ChatroomMemberConnectedMessageHandler;
